import { render, staticRenderFns } from "./areaHandle.vue?vue&type=template&id=3b0b10ad&scoped=true&"
import script from "./areaHandle.vue?vue&type=script&lang=js&"
export * from "./areaHandle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0b10ad",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2026/Temperature/TempAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b0b10ad')) {
      api.createRecord('3b0b10ad', component.options)
    } else {
      api.reload('3b0b10ad', component.options)
    }
    module.hot.accept("./areaHandle.vue?vue&type=template&id=3b0b10ad&scoped=true&", function () {
      api.rerender('3b0b10ad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/member/memberArea/areaHandle.vue"
export default component.exports